"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pin = pin;
exports.displayCenter = exports.centerXY = exports.centerY = exports.centerX = void 0;

var _styledComponents = require("styled-components");

function pin() {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  for (var _len = arguments.length, places = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    places[_key - 1] = arguments[_key];
  }

  return places.map(function (p) {
    return "".concat(p, ": ").concat(amount, "px;");
  }).join('');
}

var centerX = (0, _styledComponents.css)(["left:50%;transform:translateX(-50%);"]);
exports.centerX = centerX;
var centerY = (0, _styledComponents.css)(["top:50%;transform:translateY(-50%);"]);
exports.centerY = centerY;
var centerXY = (0, _styledComponents.css)(["left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);"]);
exports.centerXY = centerXY;
var displayCenter = (0, _styledComponents.css)(["margin-left:auto;margin-right:auto;"]);
exports.displayCenter = displayCenter;